import {io} from 'socket.io-client';

const ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT;

const socket = io(ENDPOINT,{
  autoConnect:false,
  path: '/chat-socket/'
});

export default socket;